import { Printer, type LucideIcon } from 'lucide-react';

// Organy, których EKRAN LEŻY W POWŁOCE, a nie w osobnej aplikacji modułu.
//
// `MODULE_REGISTRY` opisuje moduły montowane w iframe pod
// `/admin/modules/<slug>` i jest ŹRÓDŁEM trzech rzeczy naraz: nawigacji
// (`MODULE_NAV_ITEMS`), tras powłoki (`App.tsx`) oraz listy wyboru modułu przy
// przypisaniu drukarki (`AssignmentsTab`). Dopisanie tam organu bez własnej
// aplikacji dałoby więc pozycję w menu prowadzącą na nieistniejącą trasę i
// bezsensowną opcję „przypisz drukarkę do modułu druku" — dlatego druk stoi
// tutaj, a nie tam.
//
// Ten rejestr odpowiada tylko na dwa pytania marketplace'u: jak kafel ma
// wyglądać i dokąd prowadzi „Otwórz moduł". Bez niego karta opłaconego organu
// rysuje się szarym `Package` (fallback w `ModulesPage`), a przycisk prowadzi
// pod `/admin/modules/print`, czyli donikąd.
//
// Warstwa czysta, bez I/O — regułę da się przetestować bez Reacta i bez bazy.

export interface OrganWPowloce {
  /** `modules.id` w bazie. */
  slug: string;
  /** Nazwa na karcie w cenniku. */
  displayName: string;
  icon: LucideIcon;
  color: { bg: string; text: string; border: string };
  /** Pełna ścieżka ekranu w powłoce — to, dokąd prowadzi „Otwórz moduł". */
  sciezka: string;
}

export const ORGANY_W_POWLOCE: OrganWPowloce[] = [
  {
    slug: 'print',
    displayName: 'INSOLITUM CLOUD PRINT',
    // Printer, nie `FileText` ani `Tag`: organ obsługuje ETYKIETĘ I DOKUMENT
    // jedną kolejką, więc ikona jednego z dwóch nośników zawężałaby produkt do
    // połowy. Drukarka jest zarazem tym, co najemca ma fizycznie na stole.
    icon: Printer,
    color: {
      bg: 'bg-teal-500/20',
      text: 'text-teal-400',
      border: 'border-teal-500/30',
    },
    sciezka: '/admin/printing',
  },
];

const PO_SLUGU = new Map<string, OrganWPowloce>(ORGANY_W_POWLOCE.map((o) => [o.slug, o]));

/** Opis organu montowanego w powłoce albo `undefined`, gdy to nie ten przypadek. */
export function organWPowloce(slug: string): OrganWPowloce | undefined {
  return PO_SLUGU.get(slug);
}

/**
 * Dokąd prowadzi „Otwórz moduł" dla danego sluga.
 *
 * Domyślnie `/admin/modules/<slug>` — czyli tak, jak było, dla każdego modułu
 * w iframie. Organ z tego rejestru dostaje swoją ścieżkę w powłoce.
 */
export function sciezkaModulu(slug: string): string {
  return PO_SLUGU.get(slug)?.sciezka ?? `/admin/modules/${slug}`;
}
